var FrontMainController = {

	currentView: {},
	views: {},
	components: {},

	// Creates the list of js views objects
	initViewsList: function() {
		this.views = {
			'home-view': HomeView, 											// home.html
			'account-modification-view': AccountModificationView, 			// account-modification.html
			'payment-mode-modification-view': PaymentModeModificationView	// payment-mode-modification.html
		}
	},

	// Creates the list of js components objects
	initComponentsList: function() {
		this.components = [
			MenuTablet,
			DatePicker,
			DateRangePicker,
			MyAccount,
			LangSelect,
			CurrentStatus,
			TabsComponent,
			SelectComponent,
			ToggleHide,
			ToggleLessMore,
			ToggleDropdown,
			SearchComponent,
			Alert,
			Cookies,
			ToggleMovement,
			LoginValidate,
			RegisterValidate,
			FormKeyAccessValidate,
			RequirePasswordValidate,
			ModifyDataValidate,
			PaymentDayValidate,
			PaymentModeValidate,
			FormCommentValidate,
			NewPasswordValidate,
			AccountModificationValidate,
			SearchByDateRangeValidate
		]
	},

	// Initialization on document ready
	init: function() {

		this.initViewsList();
		this.initComponentsList();

		Footer.init();
		Menu.init();

		this.initComponents();
		this.initView();

		this.initPlugins();

		this.initToggleMovements();

		// Loading jsons configuration
		Configuration.load().done((function() {

			$.when(Language.load(), Brand.load()).done((function() {
				Language.init();
				Brand.init();
				this.endJSInit();
			}).bind(this));

		}).bind(this));
	},

	// Initialize the corresponding js view logic if exists
	initView: function() {

		var viewIdentifier = $('.main-content').attr('id');

		if (!$.isEmptyObject(this.currentView)) {
			this.currentView.unbindAll();
		}

		if (typeof this.views[viewIdentifier] !== "undefined") {
			this.currentView = this.views[viewIdentifier];
			// Initialize the corresponding view js logic
			this.views[viewIdentifier].init();
		} else {
			this.currentView = {};
		}
	},

	// Initialize components for the current view
	initComponents: function() {
		$(this.components).each(function(index, component) {
			component.init();
		});
	},

	// Special initializations for plugins
	initPlugins: function() {
		$('input, textarea').placeholder();
		$.slidebars();
	},

	initToggleMovements: function() {
		if ($('.movements-period.item').length) {
			$('.movements-period.item').first().addClass('active');
			$('.movements-period.item').first().find('.movement.subitem').show();
			$('.movements-period.item').first().find('.trigger-less-more').find('.more').removeClass('active');
			$('.movements-period.item').first().find('.trigger-less-more').find('.less').addClass('active');
		}
	},

	beforeRenderAction: function() {
		// Unbind all components events
		$(this.components).each(function(index, component) {
			component.unbindAll();
		});

		// Unbind all specific view events binding if exists js for the current view
		if (!$.isEmptyObject(this.currentView)) {
			this.currentView.unbindAll();
			this.currentView = {};
		}
	},

	afterRenderAction: function() {
		this.initComponents();
		this.initView();
	},

	endJSInit: function () {
		setTimeout(function() {
			$('.wrapper-page-content').removeClass('visibility-hidden');
			LoadingLayer.firstDOMLoad();
		}, 0);
	}
}
